import { Currency } from "../../../../lib/components/Currency";

/**
 * Compact 5-metric summary block for a payout run.
 */
export function SummaryTotals({
  commissions,
  chargebacks,
  bonuses,
  adjustments,
  rejected,
}) {
  return (
    <dl className="summary-totals">
      <Metric label="Commissions" amount={commissions} />
      <Metric label="Bonuses" amount={bonuses} />
      <Metric label="Chargebacks" amount={chargebacks} tone="danger" />
      <Metric label="Adjustments" amount={adjustments} />
      <Metric label="Declined" amount={rejected} />
    </dl>
  );
}

function Metric({ label, amount, tone, emphasis }) {
  const classes = ["summary-metric"];
  if (tone) classes.push(`summary-metric--${tone}`);
  if (emphasis) classes.push("summary-metric--emphasis");
  return (
    <div className={classes.join(" ")}>
      <dt>{label}</dt>
      <dd className="tnum">
        <Currency amount={amount} />
      </dd>
    </div>
  );
}
